<template>
  <section
    :id="id"
    class="widget-text"
  >
    <z-title
      v-if="title"
      class="widget-text__title"
      size="small"
      tag="h2"
    >
      {{ title }}
    </z-title>

    <z-dynamic-content
      class="widget-text__content"
      :class="`widget-text__content--${columns}`"
      tag="div"
    >
      <div v-html="content" />
    </z-dynamic-content>
  </section>
</template>

<script>
import { shouldBeOneOf } from 'vue-prop-validation-helper'

import { slugify } from '~/assets/js/utils/slug'

export default {
  name: 'WidgetText',
  props: {
    title: {
      type: String,
      default: '',
    },
    columns: {
      type: Number,
      default: 1,
      validator: shouldBeOneOf([1, 2, 3]),
    },
    content: {
      type: String,
      required: true,
    },
  },
  computed: {
    id () {
      if (this.title) {
        return slugify(this.title)
      }

      return undefined
    },
  },
}
</script>

<style lang="scss" scoped>
.widget-text__title {
  margin: var(--unit-0000);
  padding: var(--unit-0200) var(--unit-0000);
}

.widget-text__content::v-deep {
  & p,li {
    margin: var(--unit-0300) var(--unit-0000);
  }
  & p:first-child {
    margin-top: var(--unit-0000);
  }
  & p:last-child {
    margin-bottom: var(--unit-0000);
  }
  & ul {
    margin: var(--unit-0000);
  }
  & img {
    max-width: 100%;
  }
}

@each $column in ('1', '2', '3') {
  .widget-text__content--#{$column} {
    columns: 1;

    @media (min-width: $breakpoint-desktop) {
      columns: #{$column};
    }
  }
}
</style>
